import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { checkValidity, confirm } from '../../helpers/helpers.js';

// Translations
import translate from '../Translate.js';

// Dependencies
import Dropzone from 'react-dropzone';

// Components
import * as icons from '../Icons/Icons';
import Step from '../Common/Step';

const ExamAttachments = observer(class ExamAttachments extends React.Component {
  constructor() {
    super();
    this.handleDrop = this.handleDrop.bind(this);
    this.handleDragEnter = this.handleDragEnter.bind(this);
    this.handleDragLeave = this.handleDragLeave.bind(this);
    this.removeFile = this.removeFile.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillMount() {
    const { ExamStore } = this.props.store;

    this.state = {
      attachment: [],
      dropClass: ''
    }

    if(this.props.customConfiguration && this.props.customConfiguration.sid) {
      ExamStore.getConfigurationData(this.props.exam.sid, this.props.customConfiguration.sid);
    } else if(!this.props.exam.configuration.sid) {
      ExamStore.getExam(this.props.examSid);
    }
  }

  componentDidMount() {

  }

  handleDrop(file, rejected) {
    const { SessionStore } = this.props.store;
    let size = 0;

    console.log(file);

    if(file.length === 0) {
      const dialogContent = this.props.translation.invalid;
      SessionStore.showDialog(dialogContent);

      this.setState({
        dropClass: ''
      });
    } else {
      file.forEach(function(file){
        if(file.size) {
          size += file.size
        }
      });
    }

    if(this.state.attachment.length + file.length <= 5 && size <= 4194304) {
      let attachment = [...this.state.attachment.concat(file)];

      this.setState({
        attachment,
        dropClass: ''
      });
    } else {
      let dialogContent = this.props.translation.limit;

      if(size > 4194304) {
        dialogContent = this.props.translation.too_large;
      }

      SessionStore.showDialog(dialogContent);

      this.setState({
        dropClass: ''
      });
    }

    // Convert to binary data
    // const _this = this;
    // const newFile = file[0];
    // const reader = new FileReader();
    // let attachments = [...this.state.attachments];
    //
    // reader.onload = function(){
    //   attachments.push(reader.result);
    //   _this.setState({
    //     attachments
    //   });
    // }
    //
    // reader.readAsBinaryString(newFile);
  }

  handleDragEnter() {
    this.setState({
      dropClass: 'file-drop--drag-enter'
    });
  }

  handleDragLeave() {
    this.setState({
      dropClass: ''
    });
  }

  removeFile(i) {
    let attachment = [...this.state.attachment];
    attachment.splice(i, 1);

    this.setState({
      attachment
    });
  }

  deleteFile(file, index) {
    const { exam, store, translation } = this.props;

    const msg = {
      heading: `${translation.delete_confirm.heading} ${file}?`,
      body: translation.delete_confirm.body,
      button: translation.delete_confirm.button
    }

    const data = {
      attachments: [file]
    };

    confirm(msg, () => store.ExamStore.deleteExamAttachments(exam.sid, exam.configuration.sid, data, () => {this.removeUploadedFile(index)}));
  }

  removeUploadedFile(index) {
    this.props.exam.configuration.attachments.splice(index, 1);
  }

  handleSubmit(e) {
    e.preventDefault();

    if(this.state.attachment.length > 0) {
      const { ExamStore } = this.props.store;
      const examSid = this.props.exam.sid;
      let configurationSid = this.props.exam.configuration.sid;

      if(this.props.customConfiguration) {
        configurationSid = this.props.customConfiguration.sid;
      }

      const data = {
        attachments: this.state.attachment
      }

      ExamStore.updateExamAttachments(examSid, configurationSid, data, this.props.complete);
    } else {
      this.props.complete();
    }
  }

  render() {
    const { exam, translation } = this.props;
    const { SessionStore } = this.props.store;

    let configuration = exam.configuration;

    if(this.props.customConfiguration) {
      configuration = this.props.customConfiguration;
    }

    if(!SessionStore.loading) {
      return(
        <main tabIndex="0" id="main-content" className={`${this.props.exception ? 'drawer__content' : 'page'}`}>
          <header className={`${this.props.exception ? 'drawer__header' : 'page__header'}`}>
            <div className="wrap">
              <h1  className={`${this.props.exception ? 'drawer__title' : 'page__title'}`}>
                {this.props.exception &&
                  <span>{translation.title_exception}</span>
                }
                {!this.props.exception &&
                  <span>{translation.title}</span>
                }
              </h1>
            </div>
          </header>

          <div className="wrap block-form">
            <Step step={this.props.step} setStep={this.props.setStep} data={translation.steps} skippable={this.props.skippable} />

            <form className="exam-form panel" onSubmit={(e) => checkValidity(e, this.handleSubmit, 'form.exam-form')} noValidate>
              <div className="panel__header">
                <h3 className="panel__title"><legend>{translation.heading}</legend></h3>
              </div>

              <div className="panel__body">
                <fieldset>
                  <ul className="fields">
                    <li>
                      {!this.props.readonly &&
                        <Dropzone
                          className={`file-drop ${this.state.dropClass}`}
                          onDrop={this.handleDrop}
                          onDragEnter={this.handleDragEnter}
                          onDragLeave={this.handleDragLeave}
                          multiple={true}
                          accept={'audio/*, image/*, text/*, video/*, application/*, application/octet-stream'}
                          maxSize={4194304}
                        >
                          <label className="file-drop__label">{translation.attachment.label}</label>
                        </Dropzone>
                      }

                      {configuration.attachments.length > 0 &&
                        <span className="form-subheading attachment-heading">{translation.existing}</span>
                      }

                      {configuration.attachments.map(
                        (file, i) =>
                        <div key={i} className="file-drop__files">
                          <span>{file.attachmentAwsTitle}</span>
                          <button
                            className="btn--remove"
                            type="button"
                            onClick={() => {this.deleteFile(file.attachmentAwsTitle, i)}}
                            disabled={this.props.readonly ? true : false}
                          >
                            <icons.iconMinus />
                            <span className="meta">{translation.attachment.remove} {file.attachmentAwsTitle}</span>
                          </button>
                        </div>
                      )}

                      {this.state.attachment.length > 0 &&
                        <span className="form-subheading attachment-heading">{translation.new}</span>
                      }

                      {this.state.attachment.map(
                        (file, i) =>
                        <div key={i} className="file-drop__files">
                          <span>{file.name}</span>

                          <button
                            className="btn--remove"
                            type="button"
                            onClick={() => {this.removeFile(i)}}
                            disabled={this.props.readonly ? true : false}
                          >
                            <icons.iconMinus />
                            <span className="meta">
                              {translation.attachment.remove} {file.name}
                            </span>
                          </button>
                        </div>
                      )}
                    </li>
                  </ul>
                </fieldset>

                {!this.props.readonly &&
                  <div className="panel__actions actions">
                    <button
                      className="actions__btn actions__btn--secondary"
                      type="button"
                      onClick={this.props.complete}
                    >
                      {translation.button_skip}
                    </button>

                    {
                      (
                        configuration.attachments.length > 0 ||
                        this.state.attachment.length > 0
                      ) &&
                      <button
                        className="actions__btn actions__btn--primary"
                        disabled={
                          this.state.attachment.length === 0 &&
                          configuration.attachments.length === 0
                        }
                      >
                        {translation.button}
                      </button>
                    }
                  </div>
                }
              </div>
            </form>
          </div>
        </main>
      );
    }

    return null;
  }
})

export default translate('ExamAttachments')(ExamAttachments);



// WEBPACK FOOTER //
// ./src/app/components/ExamEdit/ExamAttachments.js